import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import LayoutHOC from "../LayoutHOC";
import { useFetchActivityLogMutation, useFetchEventsQuery } from "./AuditLogAPIS";
import ReactTableComponent from "../UniversalComponents/ReactTableComponent";
import NewPagination from "../UniversalComponents/NewPagination";
import ActivityLogFilter from "./ActivityLogFilter";
import { useFetchPersonInTableQuery } from "../../utils/customer/customerTable";
import { pushAlert } from "../../utils/alertSlice";
import { getUserToken } from "../../utils/utilityFunctions/localServices";
import { useSidebar } from "../SidebarContext";
import moment from "moment";
import ActivityLogComparison from "./AuditLogComparison";

const AuditLog = ({ customerId }) => {
  const dispatch = useDispatch();

  const [logData, setLogData] = useState([]);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(25);
  const [totalCount, setTotalCount] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [comparisonData, setActivityComparisonData] = useState({});
  const [isOpenComparisonDialog, setIsOpenComparisonDialog] = useState(false);

  // RTK Query hooks
  const [fetchActivityLog, { isLoading }] = useFetchActivityLogMutation();
  const { data: eventsData, isLoading: isEventLoading, isError: isEventError } = useFetchEventsQuery();

  const {
    data: userData,
    isLoading: isUserLoading,
    isError: isUserError,
  } = useFetchPersonInTableQuery({
    token: getUserToken(),
    data: "",
  });

  const HEADER_CONFIG = [
    { accessor_key: "created_at", label: "Date Changed" },
    { accessor_key: "user_name", label: "User" },
    { accessor_key: "module", label: "Module" },
    { accessor_key: "submodule", label: "Sub Module" },
    { accessor_key: "action", label: "Action" },
    { accessor_key: "description", label: "Description" },
    { accessor_key: "event", label: "Event" },
  ];

  useEffect(() => {
    const payload = {
      page,
      limit,
      user_ids: [],
      events: [],
      ...(customerId ? { customer_id: customerId } : {}),
    };

    fetchActivityLog(payload)
      .unwrap()
      .then((res) => {
        setLogData(
          res?.data.map((item) => {
            return { ...item, created_at: moment(item?.created_at).format("MMM D, YYYY") };
          }) || []
        );
        setTotalCount(res?.total || 0);
        setTotalPages(res?.totalPages || 1);
      })
      .catch((err) => {
        console.error("Error fetching activity logs:", err);
        setLogData([]);
        setTotalCount(0);
        setTotalPages(1);
        dispatch(
          pushAlert({
            type: "error",
            message: "Failed to load activity logs. Please try again.",
          })
        );
      });
  }, [fetchActivityLog, page, limit, dispatch]);

  const handlePageChange = (newPage) => setPage(newPage);
  const handleLimitChange = (newLimit) => {
    setLimit(newLimit);
    setPage(1);
  };

  const handleFilterApply = (filterPayload) => {
    fetchActivityLog({
      ...filterPayload,
      page,
      limit,
      ...(customerId ? { customer_id: customerId } : {}),
    })
      .unwrap()
      .then((res) => {
        setLogData(res?.data || []);
        setTotalCount(res?.total || 0);
        setTotalPages(res?.totalPages || 1);
        dispatch(
          pushAlert({
            type: "success",
            message: "Filters applied successfully!",
          })
        );
      })
      .catch((err) => {
        console.error("Error applying filters:", err);
        dispatch(
          pushAlert({
            type: "error",
            message: "Failed to apply filters. Please check inputs.",
          })
        );
      });
  };

  const handleViewDetails = (item) => {
    console.log(item, "dsnjhnjfgdf");
    setIsOpenComparisonDialog(true);
    setActivityComparisonData(item);
  };

  return (
    <div className="flex flex-col h-full">
      {/* Fixed Filter Section */}
      <div className="sticky top-0 z-10 bg-white ">
        <ActivityLogFilter
          users={userData?.data || []}
          events={eventsData?.data || []}
          onFilterChange={handleFilterApply}
          isLoading={isEventLoading || isUserLoading}
        />
      </div>

      {/* Scrollable Table Section */}
      <div className="flex-1 grow min-h-0 overflow-y-auto px-2">
        <ReactTableComponent
          headers={HEADER_CONFIG}
          body={logData}
          isPaginationComponent={
            <div className="w-full">
              <NewPagination
                currentPage={page}
                limit={limit}
                totalCount={totalCount}
                onPageChange={handlePageChange}
                onLimitChange={handleLimitChange}
                totalPages={totalPages}
              />
              {/* <div className="border-t border-[#D2DAE1] pt-2 gap-4 flex justify-between">
                <div className="flex gap-4">
                  <button className="cursor-pointer text-[#131313cc] text-[14px] font-400">Print</button>
                  <button className="cursor-pointer text-[#131313cc] text-[14px] font-400">Email</button>
                  <button className="cursor-pointer text-[#131313cc] text-[14px] font-400">More</button>
                </div>
              </div> */}
            </div>
          }
          actionColumnKey="View"
          actionColumn={(item) => {
            console.log("Itme itme item", item);
            return (
              <div
                // className={m-1}
                key={item?.id}
              >
                {item?.action === "UPDATE" ? (
                  <div className="text-[#004EFF] text-sm font-normal" onClick={() => handleViewDetails(item)}>
                    View Details
                  </div>
                ) : (
                  "--"
                )}
              </div>
            );
          }}
        />
      </div>
      {isOpenComparisonDialog && (
        <ActivityLogComparison
          open={isOpenComparisonDialog}
          onClose={() => {
            setIsOpenComparisonDialog(false);
          }}
          Data={comparisonData}
        />
      )}
    </div>
  );
};

export default AuditLog;
